import { render, staticRenderFns } from "./qualifiedInputDetail.vue?vue&type=template&id=493ddb6a&scoped=true&"
import script from "./qualifiedInputDetail.vue?vue&type=script&lang=js&"
export * from "./qualifiedInputDetail.vue?vue&type=script&lang=js&"
import style0 from "./qualifiedInputDetail.vue?vue&type=style&index=0&id=493ddb6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ddb6a",
  null
  
)

export default component.exports